import React from "react";
import {
  FormOutlined,
  SafetyCertificateOutlined,
  SendOutlined,
} from "@ant-design/icons";

const STAGES = [
  {
    icon: <FormOutlined />,
    label: "Capture",
    sub: "form submitted",
  },
  {
    icon: <SafetyCertificateOutlined />,
    label: "Gate",
    sub: "quality checked",
  },
  {
    icon: <SendOutlined />,
    label: "Campaign",
    sub: "reaches the inbox",
  },
];

/**
 * The product's real differentiator, made visible: a submission travels
 * from a public form, through the anti-spam quality gate, into a sent
 * campaign — the only part of the lead lifecycle no competitor closes
 * natively (see GTM_GOAL.md). Purely decorative CSS animation (see
 * .capture-flow in index.css); prefers-reduced-motion shows a static
 * mid-flow frame instead of looping.
 */
export default function CaptureFlowAnimation() {
  return (
    <div className="capture-flow" aria-hidden="true">
      <div className="capture-flow-packet" />
      {STAGES.map((stage, index) => (
        <React.Fragment key={stage.label}>
          <div className="capture-flow-stage" data-stage={index}>
            <div className="cf-icon">{stage.icon}</div>
            <div className="cf-label">{stage.label}</div>
            <div className="cf-sub mk-mono">{stage.sub}</div>
          </div>
          {index < STAGES.length - 1 && (
            <div className="capture-flow-arrow">→</div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
